<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
  <div>
    <div class="transition_wrap"
      
    >
    <!-- :style="{backgroundImage: 'url('+transition_img+')'}" -->
      <img :src="transition_img" width="100%">
      <!-- <van-loading type="spinner" class="transition_loading" size="50px" vertical color="#4e66ff" >加载中...</van-loading> -->
      <!-- <div class="list">
        
      </div> -->
      <img :src="loading_img" class="loading_jiazai" v-if="showActive==2"/>
      <!-- <div class="item first"></div>
      <div class="item is_center"></div>
      <div class="item last"></div> -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'TransitionLoading',
  components: {},
  props: ['showActive'],
  data () {
    return {
      transition_img: './static/img/gra_loaidng.png',
      is_show: 0,
      // loading_img: './static/img/jiazai.gif',
      loading_img: '',
    }
  },
  computed: {},
  watch: {},
  created() {
    const _this = this;

    //是否显示【active】
    if( typeof _this.showActive != 'undefined' ){
      _this.is_show = _this.showActive;
    }

    if( _this.showActive == 1 ){
      _this.transition_img = './static/img/gra_loaidng.png';
    }else if( _this.showActive == 2 ){
      _this.transition_img = './static/img/gra_loading_zxrz.png';
    }

    // console.log(_this.showActive)
    // console.log(_this.is_show)
  },
  mounted() {
  },
  destroyed() {},
  methods: {
  }
}
</script>
<style>

</style>
<style lang="less" scoped>
@keyframes fadeIn {
  0% {
  opacity: 1; /*初始状态 透明度为0*/
  }
  50% {
  opacity: 0.5; /*中间状态 透明度为0*/
  }
  100% {
  opacity: 0; /*结尾状态 透明度为1*/
  }
}
@keyframes one {
  from {
    top: 11.5%;
  }
  to {
    top: 12.5%;
  }
}

.transition_wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.3s;
  background-position: 100% 0%;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1000;
  &.active {
    animation: fadeIn 1s;
  }
  .transition_loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .list {
    position: absolute;
    top: 12%;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .item {
      height: 25px;
      width: 25px;
      border-radius: 50px;
      background-color: #c9d2e9;
      &.is_center {
        position: absolute;
        margin: 0 30px;
        // animation: one 1s infinite;
      }
    }
  }
  .item {
    position: fixed;
    top: 12%;
    left: 50%;
    transform: translate(-50%, 0);
    height: 25px;
    width: 25px;
    border-radius: 50px;
    background-color: #c9d2e9;
    animation: one 0.8s infinite;
    &.first {
      left: 40%;
      // animation-delay: 1.5s;
    }
    &.is_center {
      // animation: one 1s infinite;
      animation-delay: 1s;
    }
    &.last {
      left: 60%;
      animation-delay: 1.2s;
    }
  }
}
.loading_jiazai {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue